import React from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { AdminLayout } from '../../layouts/AdminLayout';
import { KanbanBoard } from './KanbanBoard';
import { SMTPConfiguration } from './SMTPConfiguration';
import { UserManagement } from './UserManagement';
import { AdminIntegrations } from './AdminIntegrations';
import { BackupManagement } from './BackupManagement';
import { SchedulerStatusCard } from './SchedulerStatusCard';
import { ServicesManager } from './ServicesManager';

export const AdminDashboard: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Extract current view from URL path
  const pathSegments = location.pathname.split('/');
  const currentView = pathSegments[2] || 'dashboard'; // /admin/[view] -> view

  const handleNavigate = (view: string) => {
    navigate(`/admin/${view}`);
  };

  const renderContent = () => {
    switch (currentView) {
      case 'dashboard':
        return (
          <div className="dashboard-content">
            <h1>Admin Dashboard</h1>
            <p>Welcome to Mission Control Admin Panel</p>
            <div style={{ marginTop: 24, maxWidth: 480 }}>
              <SchedulerStatusCard />
            </div>
          </div>
        );
      case 'services':
        return <ServicesManager />;
      case 'users':
        return <UserManagement />;
      case 'kanban':
        return <KanbanBoard />;
      case 'email':
        return <SMTPConfiguration />;
      case 'integrations':
        return <AdminIntegrations />;
      case 'backup-management':
        return <BackupManagement />;
      default:
        return (
          <div className="dashboard-content">
            <h1>{currentView}</h1>
            <p>This section is coming soon...</p>
          </div>
        );
    }
  };

  return (
    <AdminLayout currentView={currentView} onNavigate={handleNavigate}>
      <Routes>
        <Route path="/" element={renderContent()} />
        <Route path="/dashboard" element={renderContent()} />
        <Route path="/users" element={renderContent()} />
        <Route path="/kanban" element={renderContent()} />
        <Route path="/email" element={renderContent()} />
        <Route path="/*" element={renderContent()} />
      </Routes>
      <style>{`
        .dashboard-content {
          padding: 20px;
        }
        .dashboard-content h1 {
          color: var(--text-primary);
          margin-bottom: 16px;
        }
        .dashboard-content p {
          color: var(--text-secondary);
        }
      `}</style>
    </AdminLayout>
  );
};